function isTouchDevice() {return 'ontouchstart' in window && ! navigator.userAgent.match(/Windows NT 10/i);}
var $;!function(t){t.fn.outerHtml=function(){return 0!=this.length&&(retval="",this.each(function(){var e=this.tagName.toLowerCase();if(this.outerHTML)return retval+=this.outerHTML;var n=t.map(this.attributes,function(t){return t.name+'="'+t.value+'"'});retval+="<"+e+(n.length>0?" "+n.join(" "):"")+">"+this.innerHTML+"</"+e+">"}),retval)}}(jQuery),$=jQuery,jQuery.fn.totalOuterWidth=function(){var t=0;return this.each(function(){t+=$(this).outerWidth()}),t};
/*! @vimeo/player v2.13.0 | (c) 2020 Vimeo | MIT License | https://github.com/vimeo/player.js */
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):((e="undefined"!=typeof globalThis?globalThis:e||self).Vimeo=e.Vimeo||{},e.Vimeo.Player=t())}(this,function(){"use strict";function r(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}var e="undefined"!=typeof global&&"[object global]"==={}.toString.call(global);function i(e,t){return 0===e.indexOf(t.toLowerCase())?e:"".concat(t.toLowerCase()).concat(e.substr(0,1).toUpperCase()).concat(e.substr(1))}function l(e){return/^(https?:)?\/\/((player|www)\.)?vimeo\.com(?=$|\/)/.test(e)}function s(e){var t,n=0<arguments.length&&void 0!==e?e:{},r=n.id,o=n.url,i=r||o;if(!i)throw new Error("An id or url must be passed, either in an options object or as a data-vimeo-id or data-vimeo-url attribute.");if(t=i,!isNaN(parseFloat(t))&&isFinite(t)&&Math.floor(t)==t)return"https://vimeo.com/".concat(i);if(l(i))return i.replace("http:","https:");if(r)throw new TypeError("“".concat(r,"” is not a valid video id."));throw new TypeError("“".concat(i,"” is not a vimeo.com url."))}var t=void 0!==Array.prototype.indexOf,n="undefined"!=typeof window&&void 0!==window.postMessage;if(!(e||t&&n))throw new Error("Sorry, the Vimeo Player API is not available in this browser.");var o,a,u,c="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};function f(){if(void 0===this)throw new TypeError("Constructor WeakMap requires 'new'");if(u(this,"_id","_WeakMap_"+h()+"."+h()),0<arguments.length)throw new TypeError("WeakMap iterable is not supported")}function d(e,t){if(!v(e)||!a.call(e,"_id"))throw new TypeError(t+" method called on incompatible receiver "+typeof e)}function h(){return Math.random().toString().substring(2)}function v(e){return Object(e)===e}(o="undefined"!=typeof self?self:"undefined"!=typeof window?window:c).WeakMap||(a=Object.prototype.hasOwnProperty,u=function(e,t,n){Object.defineProperty?Object.defineProperty(e,t,{configurable:!0,writable:!0,value:n}):e[t]=n},o.WeakMap=(u(f.prototype,"delete",function(e){if(d(this,"delete"),!v(e))return!1;var t=e[this._id];return!(!t||t[0]!==e)&&(delete e[this._id],!0)}),u(f.prototype,"get",function(e){if(d(this,"get"),v(e)){var t=e[this._id];return t&&t[0]===e?t[1]:void 0}}),u(f.prototype,"has",function(e){if(d(this,"has"),!v(e))return!1;var t=e[this._id];return!(!t||t[0]!==e)}),u(f.prototype,"set",function(e,t){if(d(this,"set"),!v(e))throw new TypeError("Invalid value used as weak map key");var n=e[this._id];return n&&n[0]===e?n[1]=t:u(e,this._id,[e,t]),this}),u(f,"_polyfill",!0),f));var m,y=(function(e){var t,n,r;r=function(){var t,n,r,o,i,a,e=Object.prototype.toString,u="undefined"!=typeof setImmediate?function(e){return setImmediate(e)}:setTimeout;try{Object.defineProperty({},"x",{}),t=function(e,t,n,r){return Object.defineProperty(e,t,{value:n,writable:!0,configurable:!1!==r})}}catch(e){t=function(e,t,n){return e[t]=n,e}}function c(e,t){this.fn=e,this.self=t,this.next=void 0}function l(e,t){r.add(e,t),n=n||u(r.drain)}function s(e){var t,n=typeof e;return null==e||"object"!=n&&"function"!=n||(t=e.then),"function"==typeof t&&t}function f(){for(var e=0;e<this.chain.length;e++)!function(e,t,n){var r,o;try{!1===t?n.reject(e.msg):(r=!0===t?e.msg:t.call(void 0,e.msg))===n.promise?n.reject(TypeError("Promise-chain cycle")):(o=s(r))?o.call(r,n.resolve,n.reject):n.resolve(r)}catch(e){n.reject(e)}}(this,1===this.state?this.chain[e].success:this.chain[e].failure,this.chain[e]);this.chain.length=0}function d(e){var n,r=this;if(!r.triggered){r.triggered=!0,r.def&&(r=r.def);try{(n=s(e))?l(function(){var t=new m(r);try{n.call(e,function(){d.apply(t,arguments)},function(){h.apply(t,arguments)})}catch(e){h.call(t,e)}}):(r.msg=e,r.state=1,0<r.chain.length&&l(f,r))}catch(e){h.call(new m(r),e)}}}function h(e){var t=this;t.triggered||(t.triggered=!0,t.def&&(t=t.def),t.msg=e,t.state=2,0<t.chain.length&&l(f,t))}function v(e,n,r,o){for(var t=0;t<n.length;t++)!function(t){e.resolve(n[t]).then(function(e){r(t,e)},o)}(t)}function m(e){this.def=e,this.triggered=!1}function y(e){this.promise=e,this.state=0,this.triggered=!1,this.chain=[],this.msg=void 0}function p(e){if("function"!=typeof e)throw TypeError("Not a function");if(0!==this.__NPO__)throw TypeError("Not a promise");this.__NPO__=1;var r=new y(this);this.then=function(e,t){var n={success:"function"!=typeof e||e,failure:"function"==typeof t&&t};return n.promise=new this.constructor(function(e,t){if("function"!=typeof e||"function"!=typeof t)throw TypeError("Not a function");n.resolve=e,n.reject=t}),r.chain.push(n),0!==r.state&&l(f,r),n.promise},this.catch=function(e){return this.then(void 0,e)};try{e.call(void 0,function(e){d.call(r,e)},function(e){h.call(r,e)})}catch(e){h.call(r,e)}}var g=t({},"constructor",p,!(r={add:function(e,t){a=new c(e,t),i?i.next=a:o=a,i=a,a=void 0},drain:function(){var e=o;for(o=i=n=void 0;e;)e.fn.call(e.self),e=e.next}}));return t(p.prototype=g,"__NPO__",0,!1),t(p,"resolve",function(n){return n&&"object"==typeof n&&1===n.__NPO__?n:new this(function(e,t){if("function"!=typeof e||"function"!=typeof t)throw TypeError("Not a function");e(n)})}),t(p,"reject",function(n){return new this(function(e,t){if("function"!=typeof e||"function"!=typeof t)throw TypeError("Not a function");t(n)})}),t(p,"all",function(t){var a=this;return"[object Array]"!=e.call(t)?a.reject(TypeError("Not an array")):0===t.length?a.resolve([]):new a(function(n,e){if("function"!=typeof n||"function"!=typeof e)throw TypeError("Not a function");var r=t.length,o=Array(r),i=0;v(a,t,function(e,t){o[e]=t,++i===r&&n(o)},e)})}),t(p,"race",function(t){var r=this;return"[object Array]"!=e.call(t)?r.reject(TypeError("Not an array")):new r(function(n,e){if("function"!=typeof n||"function"!=typeof e)throw TypeError("Not a function");v(r,t,function(e,t){n(t)},e)})}),p},(n=c)[t="Promise"]=n[t]||r(),e.exports&&(e.exports=n[t])}(m={exports:{}}),m.exports),p=new WeakMap;function g(e,t,n){var r=p.get(e.element)||{};t in r||(r[t]=[]),r[t].push(n),p.set(e.element,r)}function w(e,t){return(p.get(e.element)||{})[t]||[]}function b(e,t,n){var r=p.get(e.element)||{};if(!r[t])return!0;if(!n)return r[t]=[],p.set(e.element,r),!0;var o=r[t].indexOf(n);return-1!==o&&r[t].splice(o,1),p.set(e.element,r),r[t]&&0===r[t].length}var k=["autopause","autoplay","background","byline","color","controls","dnt","height","id","loop","maxheight","maxwidth","muted","playsinline","portrait","responsive","speed","texttrack","title","transparent","url","width"];function E(r,e){var t=1<arguments.length&&void 0!==e?e:{};return k.reduce(function(e,t){var n=r.getAttribute("data-vimeo-".concat(t));return!n&&""!==n||(e[t]=""===n?1:n),e},t)}function T(e,t){var n=e.html;if(!t)throw new TypeError("An element must be provided");if(null!==t.getAttribute("data-vimeo-initialized"))return t.querySelector("iframe");var r=document.createElement("div");return r.innerHTML=n,t.appendChild(r.firstChild),t.setAttribute("data-vimeo-initialized","true"),t.querySelector("iframe")}function F(i,e,t){var a=1<arguments.length&&void 0!==e?e:{},u=2<arguments.length?t:void 0;return new Promise(function(t,n){if(!l(i))throw new TypeError("“".concat(i,"” is not a vimeo.com url."));var e="https://vimeo.com/api/oembed.json?url=".concat(encodeURIComponent(i));for(var r in a)a.hasOwnProperty(r)&&(e+="&".concat(r,"=").concat(encodeURIComponent(a[r])));var o=new("XDomainRequest"in window?XDomainRequest:XMLHttpRequest);o.open("GET",e,!0),o.onload=function(){if(404!==o.status)if(403!==o.status)try{var e=JSON.parse(o.responseText);if(403===e.domain_status_code)return T(e,u),void n(new Error("“".concat(i,"” is not embeddable.")));t(e)}catch(e){n(e)}else n(new Error("“".concat(i,"” is not embeddable.")));else n(new Error("“".concat(i,"” was not found.")))},o.onerror=function(){var e=o.status?" (".concat(o.status,")"):"";n(new Error("There was an error fetching the embed code from Vimeo".concat(e,".")))},o.send()})}function _(e){if("string"==typeof e)try{e=JSON.parse(e)}catch(e){return console.warn(e),{}}return e}function M(e,t,n){var r,o;e.element.contentWindow&&e.element.contentWindow.postMessage&&(r={method:t},void 0!==n&&(r.value=n),8<=(o=parseFloat(navigator.userAgent.toLowerCase().replace(/^.*msie (\d+).*$/,"$1")))&&o<10&&(r=JSON.stringify(r)),e.element.contentWindow.postMessage(r,e.origin))}function P(n,r){var t,e,o=[];(r=_(r)).event?("error"===r.event&&w(n,r.data.method).forEach(function(e){var t=new Error(r.data.message);t.name=r.data.name,e.reject(t),b(n,r.data.method,e)}),o=w(n,"event:".concat(r.event)),t=r.data):!r.method||(e=function(e,t){var n=w(e,t);if(n.length<1)return!1;var r=n.shift();return b(e,t,r),r}(n,r.method))&&(o.push(e),t=r.value),o.forEach(function(e){try{if("function"==typeof e)return void e.call(n,t);e.resolve(t)}catch(e){}})}var x,j,C,N=new WeakMap,A=new WeakMap,S={},Player=function(){function Player(u){var e,t,c=this,n=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{};if(!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,Player),window.jQuery&&u instanceof jQuery&&(1<u.length&&window.console&&console.warn&&console.warn("A jQuery object with multiple elements was passed, using the first element."),u=u[0]),"undefined"!=typeof document&&"string"==typeof u&&(u=document.getElementById(u)),e=u,!Boolean(e&&1===e.nodeType&&"nodeName"in e&&e.ownerDocument&&e.ownerDocument.defaultView))throw new TypeError("You must pass either a valid element or a valid id.");if("IFRAME"===u.nodeName||(t=u.querySelector("iframe"))&&(u=t),"IFRAME"===u.nodeName&&!l(u.getAttribute("src")||""))throw new Error("The player element passed isn’t a Vimeo embed.");if(N.has(u))return N.get(u);this._window=u.ownerDocument.defaultView,this.element=u,this.origin="*";var r,o=new y(function(i,a){var e;c._onMessage=function(e){if(l(e.origin)&&c.element.contentWindow===e.source){"*"===c.origin&&(c.origin=e.origin);var t=_(e.data);if(t&&"error"===t.event&&t.data&&"ready"===t.data.method){var n=new Error(t.data.message);return n.name=t.data.name,void a(n)}var r=t&&"ready"===t.event,o=t&&"ping"===t.method;if(r||o)return c.element.setAttribute("data-ready","true"),void i();P(c,t)}},c._window.addEventListener("message",c._onMessage),"IFRAME"!==c.element.nodeName&&F(s(e=E(u,n)),e,u).then(function(e){var t,n,r,o=T(e,u);return c.element=o,c._originalElement=u,t=u,n=o,r=p.get(t),p.set(n,r),p.delete(t),N.set(c.element,c),e}).catch(a)});return A.set(this,o),N.set(this.element,this),"IFRAME"===this.element.nodeName&&M(this,"ping"),S.isEnabled&&(r=function(){return S.exit()},S.on("fullscreenchange",function(){(S.isFullscreen?g:b)(c,"event:exitFullscreen",r),c.ready().then(function(){M(c,"fullscreenchange",S.isFullscreen)})})),this}var e,t,n;return e=Player,(t=[{key:"callMethod",value:function(n,e){var r=this,o=1<arguments.length&&void 0!==e?e:{};return new y(function(e,t){return r.ready().then(function(){g(r,n,{resolve:e,reject:t}),M(r,n,o)}).catch(t)})}},{key:"get",value:function(n){var r=this;return new y(function(e,t){return n=i(n,"get"),r.ready().then(function(){g(r,n,{resolve:e,reject:t}),M(r,n)}).catch(t)})}},{key:"set",value:function(n,r){var o=this;return new y(function(e,t){if(n=i(n,"set"),null==r)throw new TypeError("There must be a value to set.");return o.ready().then(function(){g(o,n,{resolve:e,reject:t}),M(o,n,r)}).catch(t)})}},{key:"on",value:function(e,t){if(!e)throw new TypeError("You must pass an event name.");if(!t)throw new TypeError("You must pass a callback function.");if("function"!=typeof t)throw new TypeError("The callback must be a function.");0===w(this,"event:".concat(e)).length&&this.callMethod("addEventListener",e).catch(function(){}),g(this,"event:".concat(e),t)}},{key:"off",value:function(e,t){if(!e)throw new TypeError("You must pass an event name.");if(t&&"function"!=typeof t)throw new TypeError("The callback must be a function.");b(this,"event:".concat(e),t)&&this.callMethod("removeEventListener",e).catch(function(e){})}},{key:"loadVideo",value:function(e){return this.callMethod("loadVideo",e)}},{key:"ready",value:function(){var e=A.get(this)||new y(function(e,t){t(new Error("Unknown player. Probably unloaded."))});return y.resolve(e)}},{key:"addCuePoint",value:function(e,t){var n=1<arguments.length&&void 0!==t?t:{};return this.callMethod("addCuePoint",{time:e,data:n})}},{key:"removeCuePoint",value:function(e){return this.callMethod("removeCuePoint",e)}},{key:"enableTextTrack",value:function(e,t){if(!e)throw new TypeError("You must pass a language.");return this.callMethod("enableTextTrack",{language:e,kind:t})}},{key:"disableTextTrack",value:function(){return this.callMethod("disableTextTrack")}},{key:"pause",value:function(){return this.callMethod("pause")}},{key:"play",value:function(){return this.callMethod("play")}},{key:"requestFullscreen",value:function(){return S.isEnabled?S.request(this.element):this.callMethod("requestFullscreen")}},{key:"exitFullscreen",value:function(){return S.isEnabled?S.exit():this.callMethod("exitFullscreen")}},{key:"getFullscreen",value:function(){return S.isEnabled?y.resolve(S.isFullscreen):this.get("fullscreen")}},{key:"unload",value:function(){return this.callMethod("unload")}},{key:"destroy",value:function(){var t=this;return new y(function(e){A.delete(t),N.delete(t.element),t._originalElement&&(N.delete(t._originalElement),t._originalElement.removeAttribute("data-vimeo-initialized")),t.element&&"IFRAME"===t.element.nodeName&&t.element.parentNode&&t.element.parentNode.removeChild(t.element),t._window.removeEventListener("message",t._onMessage),e()})}},{key:"getAutopause",value:function(){return this.get("autopause")}},{key:"setAutopause",value:function(e){return this.set("autopause",e)}},{key:"getBuffered",value:function(){return this.get("buffered")}},{key:"getChapters",value:function(){return this.get("chapters")}},{key:"getCurrentChapter",value:function(){return this.get("currentChapter")}},{key:"getColor",value:function(){return this.get("color")}},{key:"setColor",value:function(e){return this.set("color",e)}},{key:"getCuePoints",value:function(){return this.get("cuePoints")}},{key:"getCurrentTime",value:function(){return this.get("currentTime")}},{key:"setCurrentTime",value:function(e){return this.set("currentTime",e)}},{key:"getDuration",value:function(){return this.get("duration")}},{key:"getEnded",value:function(){return this.get("ended")}},{key:"getLoop",value:function(){return this.get("loop")}},{key:"setLoop",value:function(e){return this.set("loop",e)}},{key:"setMuted",value:function(e){return this.set("muted",e)}},{key:"getMuted",value:function(){return this.get("muted")}},{key:"getPaused",value:function(){return this.get("paused")}},{key:"getPlaybackRate",value:function(){return this.get("playbackRate")}},{key:"setPlaybackRate",value:function(e){return this.set("playbackRate",e)}},{key:"getPlayed",value:function(){return this.get("played")}},{key:"getQualities",value:function(){return this.get("qualities")}},{key:"getQuality",value:function(){return this.get("quality")}},{key:"setQuality",value:function(e){return this.set("quality",e)}},{key:"getSeekable",value:function(){return this.get("seekable")}},{key:"getSeeking",value:function(){return this.get("seeking")}},{key:"getTextTracks",value:function(){return this.get("textTracks")}},{key:"getVideoEmbedCode",value:function(){return this.get("videoEmbedCode")}},{key:"getVideoId",value:function(){return this.get("videoId")}},{key:"getVideoTitle",value:function(){return this.get("videoTitle")}},{key:"getVideoWidth",value:function(){return this.get("videoWidth")}},{key:"getVideoHeight",value:function(){return this.get("videoHeight")}},{key:"getVideoUrl",value:function(){return this.get("videoUrl")}},{key:"getVolume",value:function(){return this.get("volume")}},{key:"setVolume",value:function(e){return this.set("volume",e)}}])&&r(e.prototype,t),n&&r(e,n),Player}();return e||(x=function(){for(var e,t=[["requestFullscreen","exitFullscreen","fullscreenElement","fullscreenEnabled","fullscreenchange","fullscreenerror"],["webkitRequestFullscreen","webkitExitFullscreen","webkitFullscreenElement","webkitFullscreenEnabled","webkitfullscreenchange","webkitfullscreenerror"],["webkitRequestFullScreen","webkitCancelFullScreen","webkitCurrentFullScreenElement","webkitCancelFullScreen","webkitfullscreenchange","webkitfullscreenerror"],["mozRequestFullScreen","mozCancelFullScreen","mozFullScreenElement","mozFullScreenEnabled","mozfullscreenchange","mozfullscreenerror"],["msRequestFullscreen","msExitFullscreen","msFullscreenElement","msFullscreenEnabled","MSFullscreenChange","MSFullscreenError"]],n=0,r=t.length,o={};n<r;n++)if((e=t[n])&&e[1]in document){for(n=0;n<e.length;n++)o[t[0][n]]=e[n];return o}return!1}(),j={fullscreenchange:x.fullscreenchange,fullscreenerror:x.fullscreenerror},C={request:function(o){return new Promise(function(e,t){function n(){C.off("fullscreenchange",n),e()}C.on("fullscreenchange",n);var r=(o=o||document.documentElement)[x.requestFullscreen]();r instanceof Promise&&r.then(n).catch(t)})},exit:function(){return new Promise(function(t,e){var n,r;C.isFullscreen?(n=function e(){C.off("fullscreenchange",e),t()},C.on("fullscreenchange",n),(r=document[x.exitFullscreen]())instanceof Promise&&r.then(n).catch(e)):t()})},on:function(e,t){var n=j[e];n&&document.addEventListener(n,t)},off:function(e,t){var n=j[e];n&&document.removeEventListener(n,t)}},Object.defineProperties(C,{isFullscreen:{get:function(){return Boolean(document[x.fullscreenElement])}},element:{enumerable:!0,get:function(){return document[x.fullscreenElement]}},isEnabled:{enumerable:!0,get:function(){return Boolean(document[x.fullscreenEnabled])}}}),S=C,function(e){function n(e){"console"in window&&console.error&&console.error("There was an error creating an embed: ".concat(e))}var t=0<arguments.length&&void 0!==e?e:document;[].slice.call(t.querySelectorAll("[data-vimeo-id], [data-vimeo-url]")).forEach(function(t){try{if(null!==t.getAttribute("data-vimeo-defer"))return;var e=E(t);F(s(e),e,t).then(function(e){return T(e,t)}).catch(n)}catch(e){n(e)}})}(),function(e){var r=0<arguments.length&&void 0!==e?e:document;window.VimeoPlayerResizeEmbeds_||(window.VimeoPlayerResizeEmbeds_=!0,window.addEventListener("message",function(e){if(l(e.origin)&&e.data&&"spacechange"===e.data.event)for(var t=r.querySelectorAll("iframe"),n=0;n<t.length;n++)if(t[n].contentWindow===e.source){t[n].parentElement.style.paddingBottom="".concat(e.data.data[0].bottom,"px");break}}))}()),Player});

/*!
* jQueryTouch v0.0.6
* https://github.com/a-fung/jQueryTouch
*
* Copyright 2012 Man Kwan Liu
* Released under the Apache License Version 2.0
* http://www.apache.org/licenses/
*
* Date: Wed Oct 2012 23:14:09 GMT-0700 (Pacific Daylight Time)
*/ !function(e){e.fn.touchInit=function(t){if(t&&"object"==typeof t||(t={}),0==(t=e.extend({preventDefault:!0,mouse:!0,pen:!0,maxtouch:-1,prefix:""},t)).maxtouch)return this;if(window.navigator.msPointerEnabled&&t.preventDefault){var n=this.data("_touchtrack-ms-touch-action");(void 0==n||null==n)&&(n=[]),n[t.prefix+"_track"]=!0,this.data("_touchtrack-ms-touch-action",n),this.css("-ms-touch-action","none")}return this.each(function(){var n=this,o=null,i=null;e(this).data(t.prefix+"_touches",[]),o=function(r){var c=[];if(r.pointerType){if(r.pointerType==r.MSPOINTER_TYPE_MOUSE&&!t.mouse||r.pointerType==r.MSPOINTER_TYPE_PEN&&!t.pen)return;c[0]={id:r.pointerId,clientX:r.clientX,clientY:r.clientY,pageX:r.pageX,pageY:r.pageY,screenX:r.screenX,screenY:r.screenY}}else if(r.changedTouches)for(var s=0;s<r.changedTouches.length;s++)c[s]={id:r.changedTouches[s].identifier,clientX:r.changedTouches[s].clientX,clientY:r.changedTouches[s].clientY,pageX:r.changedTouches[s].pageX,pageY:r.changedTouches[s].pageY,screenX:r.changedTouches[s].screenX,screenY:r.changedTouches[s].screenY};else c[0]={id:-1,clientX:r.clientX,clientY:r.clientY,pageX:r.pageX,pageY:r.pageY,screenX:r.screenX,screenY:r.screenY};for(var s=0;s<c.length;s++){var a,u=c[s],h=null,p=!0;i=e(n).data(t.prefix+"_touches");for(var f=0;f<i.length;f++)if(i[f].id==u.id){p=!1,i[f]=u,e(n).data(t.prefix+"_touches",i),h=f;break}if(!p||this==n){if("touchstart"==r.type||"MSPointerDown"==r.type||"mousedown"==r.type){if(p){if(!(t.maxtouch<0)&&!(t.maxtouch>i.length))continue;i[i.length]=u,e(this).data(t.prefix+"_touches",i),r.pointerType?(document.addEventListener("MSPointerMove",o,!1),document.addEventListener("MSPointerUp",o,!1),document.addEventListener("MSPointerCancel",o,!1)):(document.addEventListener("touchmove",o,!1),document.addEventListener("touchend",o,!1),document.addEventListener("touchcancel",o,!1),t.mouse&&(e(document).on("mousemove",o),e(document).on("mouseup",o)))}a="start"}else if("touchmove"==r.type||"MSPointerMove"==r.type||"mousemove"==r.type)a="move";else{if("touchend"!=r.type&&"touchcancel"!=r.type&&"MSPointerUp"!=r.type&&"MSPointerCancel"!=r.type&&"mouseup"!=r.type)continue;i.length-1!=h&&(i[h]=i[i.length-1]),i.pop(),e(n).data(t.prefix+"_touches",i),0==i.length&&(r.pointerType?(document.removeEventListener("MSPointerMove",o,!1),document.removeEventListener("MSPointerUp",o,!1),document.removeEventListener("MSPointerCancel",o,!1)):(document.removeEventListener("touchmove",o,!1),document.removeEventListener("touchend",o,!1),document.removeEventListener("touchcancel",o,!1),t.mouse&&(e(document).off("mousemove",o),e(document).off("mouseup",o)))),a="end"}var v=e.Event(t.prefix+"touch_"+a);v=e.extend(v,{originalType:r.type,clientX:u.clientX,clientY:u.clientY,pageX:u.pageX,pageY:u.pageY,screenX:u.screenX,screenY:u.screenY,touches:i});try{e(n).trigger(v)}catch(l){console.log(l)}}}if(t.preventDefault)return r.preventDefault&&r.preventDefault(),!1},window.navigator.msPointerEnabled?this.addEventListener("MSPointerDown",o,!1):(this.addEventListener("touchstart",o,!1),t.mouse&&e(this).on("mousedown",o)),e(this).data(t.prefix+"_touch_handler",o)}),this},e.fn.touchDispose=function(t){if(t&&"string"==typeof t||(t=""),window.navigator.msPointerEnabled){var n=this.data("_touchtrack-ms-touch-action");(void 0==n||null==n)&&(n=[]),delete n[options.prefix+"_track"],this.data("_touchtrack-ms-touch-action",n);var o=0;for(j in n)o++;0==o&&this.css("-ms-touch-action","")}return this.each(function(){var n=e(this).data(t+"_touch_handler");this.removeEventListener("MSPointerDown",n,!1),this.removeEventListener("touchstart",n,!1),e(this).off("mousedown",n),document.removeEventListener("MSPointerMove",n,!1),document.removeEventListener("MSPointerUp",n,!1),document.removeEventListener("MSPointerCancel",n,!1),document.removeEventListener("touchmove",n,!1),document.removeEventListener("touchend",n,!1),document.removeEventListener("touchcancel",n,!1),e(this).off("mousemove",n),e(this).off("mouseup",n),e(this).removeData(t+"_touch_handler"),e(this).removeData(t+"_touches")}),this}}(jQuery),/*!
* jQueryTouch v0.0.6
* https://github.com/a-fung/jQueryTouch
*
* Copyright 2012 Man Kwan Liu
* Released under the Apache License Version 2.0
* http://www.apache.org/licenses/
*
* Date: Wed Oct 2012 23:14:09 GMT-0700 (Pacific Daylight Time)
*/ function(e){e.fn.swipe=function(t,n){if("function"!=typeof t)return this;n&&"object"==typeof n||(n={});var o,i,r,c={preventDefault:(n=e.extend({preventDefault:!1,mouse:!0,pen:!0,distance:50},n)).preventDefault,mouse:n.mouse,pen:n.pen,maxtouch:1,prefix:"_swipe_"},s=function(e){return e*e},a=function(e){if("_swipe_touch_start"==e.type)o=!0,i=e.pageX,r=e.pageY;else{if(o&&Math.sqrt(s(e.pageX-i)+s(e.pageY-r))>=n.distance){o=!1;var c,a=Math.atan2(e.pageY-r,e.pageX-i)/Math.PI*8;if(a<-7)c="left";else if(a<-5)return c="upleft",!0;else if(a<-3)return c="up",!0;else if(a<-1)return c="upright",!0;else if(a<1)c="right";else{if(a<3)return c="downright",!0;if(a<5)return c="down",!0;if(a<7)return c="downleft",!0;c="left"}try{t(c)}catch(u){console.log(u)}}"_swipe_touch_end"==e.type&&(o=!1)}};return this.touchInit(c),this.on("_swipe_touch_start",a),this.on("_swipe_touch_move",a),this.on("_swipe_touch_end",a),this}}(jQuery);


(function($){
    $.fn.outerHtml = function() {
        if (this.length == 0) return false;
        retval = "";
        this.each(function() {
            var elem = this, name = elem.tagName.toLowerCase();
            if (elem.outerHTML) return retval += elem.outerHTML;
            var attrs = $.map(elem.attributes, function(i) { return i.name+'="'+i.value+'"'; });
            retval += "<"+name+(attrs.length > 0 ? " "+attrs.join(" ") : "")+">"+elem.innerHTML+"</"+name+">";
        });
        return retval;
    };
})(jQuery);

(function( $ ) {
    jQuery.fn.totalOuterWidth = function() {
        var tow = 0;
        this.each(function() {
            tow+=$(this).outerWidth();
        });
        return tow;
    };
})( jQuery );

(function( $ ) {
    jQuery.fn.totalOuterHeight = function() {
        var toh = 0;
        this.each(function() {
            toh+=$(this).outerHeight();
        });
        return toh;
    };
})( jQuery );

/*
 *  Deep Slider Unified
 *  First introduction: 28.06.2023
 *  Last Update: 29.06.2023
 *  Version 2.0.1
 */
(function ($) {
    var config, time, w,

        windowResized = function (config) {

            if (config.sameHeightItems || config.method === "fade") {
                $(config.items, config.elToMove).removeClass('setHeight').css({'height': ''});
                var h = 0;
                $(config.items, config.elToMove).each(function () {
                    if ($(this).outerHeight() > h) {
                        h = $(this).outerHeight();
                    }
                });
                $(config.items, config.elToMove).addClass('setHeight').css({'height': h});
                if (config.method === "fade") {

                    $(config.elToMove, config.cont).css({'height': h});
                }
            }

            if (config.method === "slide") {
                slideToElement(config.current_item);
            }
        },
        clickRight = function (config) {

            var i;

            if (config.current_item + config.moveByElements >= config.items_number
                || config.current_item + config.visibleItems >= config.items_number) {
                i = 0;
            } else {
                i = config.current_item + config.moveByElements;
            }

            if (config.continuousRewindEnabled && i === 0) {
                config.elToMove.css({
                    marginLeft: -$(config.items + ':lt(' + (config.items_number - 1) + ')', config.elToMove).totalOuterWidth()
                });
            }

            jumpToElement(i);
        },
        clickLeft = function (config) {

            var i;

            if (config.visibleItems && config.current_item - config.moveByElements < 0 ) {
                i = config.items_number - config.visibleItems;
            } else if (config.current_item - config.moveByElements < 0) {
                i = config.items_number - config.moveByElements;
            } else {
                i = config.current_item - config.moveByElements;
            }

            if (config.continuousRewindEnabled && i === config.items_number - 1) {
                config.elToMove.css({
                    marginLeft: -$(config.items + ':lt(' + (2 * config.items_number) + ')', config.elToMove).totalOuterWidth()
                });
            }
            if (config.continuousRewind && $.inArray(config.method, ['cascade-left', 'cascade']) !== -1) {
                if (i === (config.items_number - 1)) {
                    i = config.items_number - 2;
                }
            }

            jumpToElement(i);
        },
        calculateCurrItem = function () {
            var calculatedCurrItem = 0;
            var l = parseInt(config.elToMove.css('marginLeft'));
            var w = 0;
            $(config.items, config.elToMove).each(function () {
                w += $(this).outerWidth();
                if (-w < l) return false;
                calculatedCurrItem++;
            });

            return calculatedCurrItem;
        },
        slideToElement = function (i) {
            if (config.continuousRewindEnabled) {
                $(config.items, config.elToMove).removeClass('current original');
                $(config.items, config.elToMove).eq(i).addClass('current');
                i = i + config.items_number;
                $(config.items, config.elToMove).eq(i).addClass('current original');
                $(config.items, config.elToMove).eq(i + config.items_number).addClass('current');
            }

            var l = -$(config.items + ':lt(' + i + ')', config.elToMove).totalOuterWidth();

            if ($(config.cont).data('slideby')) {
                l = -(parseInt($(config.cont).data('slideby')) * $(config.items + ':lt(' + i + ')', config.elToMove).length);
            }

            if ($(config.cont).hasClass('enabled')) {
                config.elToMove.stop().animate({marginLeft: l}, config.time, 'linear');
            } else {
                config.elToMove.css({marginLeft: l});
            }
        },
        jumpToElement = function (i) {
            if (!config) return;
            if (config.disableButtons) {
                if (config.leftButton) {
                    i === 0 ? config.leftButton.addClass('disabled') : config.leftButton.removeClass('disabled');
                }
                if (config.rightButton) {
                    i + config.moveByElements >= config.items_number ? config.rightButton.addClass('disabled') : config.rightButton.removeClass('disabled');
                }
            }

            config.current_item = i;
            $('li.active', config.nav).removeClass('active');
            $('li', config.nav).eq(Math.ceil(i / config.moveByElements)).addClass('active');
            if (!config.continuousRewindEnabled) {
                $(config.items, config.elToMove).eq(i).addClass('current').siblings().removeClass('current');
            }

            if (config.method === "slide") {
                slideToElement(i);
            }
            if (config.jumpToElementCallback) {
                config.jumpToElementCallback(i % config.items_number, config.cont, config);
            }

            if (config.continuousRewind && $.inArray(config.method, ['cascade-left', 'cascade']) !== -1) {
                if (config.current_item === (config.items_number - 1)) {
                    setTimeout(function () {
                        $(config.elToMove).addClass('blockTransition');
                        clickRight(config);
                        setTimeout(function () {
                            $(config.elToMove).removeClass('blockTransition');
                        }, (config.time + 200));
                    }, (config.time + 200));
                }
            }
        },
        createNav = function () {

            $('li', config.nav).remove();
            if ($(config.items, config.elToMove).length < 2) {
                return;
            }

            var i = 0;
            var l = $(config.items, config.elToMove).length;
            if (config.moveByElements > 1) {
                l = Math.ceil(l / config.moveByElements);
            }
            for (; l > 0; l--) {
                i++;
                var content = '', num;
                var title = $(config.items, config.elToMove).eq(i - 1).data('title');
                var c = '';
                if (title) {
                    num = title;
                    c = 't';
                } else {
                    num = i.toString();
                    num = num.length < 2 ? "0" + num : num;
                }
                content += config.numbersNav ? '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none"><circle cx="13" cy="13" r="12" transform="rotate(-90 13 13)" stroke="black" stroke-width="2"/></svg><span class="text">' + num  + '</span>' : "&nbsp;";

                config.numbersNav ? config.nav.addClass('numbersNav') : config.nav.addClass('dots')

                config.nav.append('<li class="' + c + '">' + content + '</li>');
            }
            ;
            $('li:eq(' + calculateCurrItem() + ')', config.nav).addClass('active');
        },
        navClicked = function () {
            config = $(this).data('sliderConfig');
            clearInterval(config.intervalID);
            if (config.dontStopAfterClick && config.delay > -1) config.intervalID = setInterval(clickRight, config.delay);
            var index = $("li", config.nav).index(this);
            if (config.moveByElements > 1 ) {
                index *= config.moveByElements;
            }
            jumpToElement(index);
            return false;
        },
        initialize = function (t, options) {

            config = t.data('sliderConfig');

            if (options.jumpToElement !== undefined) {
                jumpToElement(options.jumpToElement);
                return;
            }

            if (!config && $.type(options) !== "string") {
                config = {};
            }

            if (options) {
                $.extend(config, options);
            }
            config.cont = $(t);
            if (options === "destroy") {
                config = $(t).data('sliderConfig');
                if (typeof config === "undefined") return;
                clearInterval(config.intervalID);
                $(config.items + ":gt(" + (config.items_number - 1) + ")", config.elToMove).remove();
                $(config.rightButton).unbind();
                $(config.leftButton).unbind();
                return;
            }
            if (options === "clickRight") return clickRight(config);
            if (options === "clickLeft") return clickLeft(config);
            if (options === "windowResized") return windowResized(config);

            if (!t.length) return;
            if (!options) options = {};

            config.dontStopAfterClick = (options.dontStopAfterClick) ? true : false;

            config.method = options.method ? options.method : 'slide';
            config.continuousRewindEnabled = options.continuousRewind ? options.continuousRewind : false;
            if (config.method !== 'slide') {
                config.continuousRewindEnabled = false;
            }
            config.moveByElements = options.moveByElements ? options.moveByElements : 1;
            config.visibleItems = options.visibleItems ? options.visibleItems : 1;
            if (options.portraitVisibleItems && $(window).width() < 1024 && $(window).width() >= 768) {
                config.visibleItems = options.portraitVisibleItems;
            } else if (options.mobileVisibleItems && $(window).width() < 768) {
                config.visibleItems = options.mobileVisibleItems;
            }
            config.sameHeightItems = options.sameHeightItems ? options.sameHeightItems : false;
            config.current_item = options.currentItem ? options.currentItem : 0;
            config.time = options.time ? options.time : 500;

            if (options.delay) config.delay = options.delay; else config.delay = -1;

            if (options.elToMove) config.elToMove = $(options.elToMove, config.cont).eq(0); else config.elToMove = $(config.items, config.cont).eq(0);
            if (options.nav) config.nav = $(options.nav, config.cont); else config.nav = $('');
            if (options.numbersNav) config.numbersNav = $(options.numbersNav, config.cont); else config.numbersNav = false;
            if (options.createNav) createNav();

            if (options.rightButton) {
                config.rightButton = $(options.rightButton, config.cont);
                $(config.rightButton).click(function () {
                    if ($(this).hasClass('disabled')) return false;
                    config = $(this).data('slider').data('sliderConfig');
                    clearInterval(config.intervalID);
                    if (config.dontStopAfterClick && config.delay > -1) config.intervalID = setInterval(clickRight, config.delay);
                    clickRight(config);
                    $(this).blur();
                    return false;
                }).data('slider', t);
            }
            if (options.leftButton) {
                config.leftButton = $(options.leftButton, config.cont);
                $(config.leftButton).click(function () {
                    if ($(this).hasClass('disabled')) return false;
                    config = $(this).data('slider').data('sliderConfig');
                    clearInterval(config.intervalID);
                    if (config.dontStopAfterClick && config.delay > -1) config.intervalID = setInterval(clickRight, config.delay);
                    clickLeft(config);
                    $(this).blur();
                    return false;
                }).data('slider', t);
            }
            config.disableButtons = options.disableButtons ? options.disableButtons : false;

            w = $(config.items, config.elToMove).eq(0).outerWidth();
            config.items_number = $(config.items, config.elToMove).length;
            if (config.items_number < 2) {
                $(config.rightButton).hide();
                $(config.leftButton).hide();
                $(config.nav).hide();
                $(config.items).eq(0).addClass('current');
                return;
            }
            var _this = t;
            if (config.delay > -1) {
                config.intervalID = setInterval(function () {
                    _this.slider('clickRight');
                }, config.delay);
            }
            if (config.nav) $('li', config.nav).data('sliderConfig', config).click(navClicked);
            if (config.continuousRewindEnabled) {
                // tripple the items
                var items_html = $(config.items + ":lt(" + config.items_number + ")", config.elToMove).outerHtml();
                $(config.items, config.elToMove).parent().append(items_html + items_html);
                config.disableButtons = false;
                config.moveByElements = 1;
                $(config.items + ":lt(" + config.items_number + ")", config.elToMove).addClass('before');
            }

            if (config.continuousRewind && $.inArray(config.method, ['cascade-left', 'cascade']) !== -1) {
                var additional_item = $(config.items + ":eq(0)", config.elToMove).outerHtml()
                $(config.elToMove).append(additional_item);
                $(config.elToMove).find('> *:last-child').addClass('additional');
                config.items_number++;
            }

            config.itemsNavigate = options.itemsNavigate ? options.itemsNavigate : false;
            if (config.itemsNavigate) {
                config.itemsCurrent = options.itemsCurrent ? options.itemsCurrent : 0;
                $(config.items, config.elToMove).on('click', function() {
                    config = $(this).data('slider').data('sliderConfig');
                    var i = (($(this).index() + 1) % config.items_number) - 1;
                    i -= config.itemsCurrent;
                    jumpToElement(i);
                }).data('slider', t);
            }

            t.data('sliderConfig', config);

            $(window).resize(function () {
                _this.slider('windowResized');
            });

            windowResized(config);

            jumpToElement(config.current_item);

            $(config.cont).addClass('enabled method-' + config.method)
        };

    $.fn.deepSlider3 = function (options) {
        this.each(function () {
            initialize($(this), options);
        });
    };
})(jQuery);

var load_products = function() {};

jQuery(document).ready(function ($) {

    var $h = $('html');
    var $b = $('body');

    isTouchDevice() ? $h.addClass('touch') : $h.addClass('no-touch');

    function slider_init() {
        slider_swiper_loop();
        new Swiper('.swiper.no-loop', {
            slidesPerView: 'auto',
            loop: false,
            navigation: {
                prevEl: '.prev-slide',
                nextEl: '.next-slide',
            },
            pagination: {
                el: ".nav",
                clickable: true,
            },
        });
        if ($(window).width() < 768 && $('[data-mob-swiper]').length) {
            $('[data-mob-swiper]').addClass('swiper mobile deepSlider1');
            new Swiper('.swiper.mobile', {
                slidesPerView: 'auto',
                loop: false,
                navigation: {
                    prevEl: '.prev-slide',
                    nextEl: '.next-slide',
                },
                pagination: {
                    el: ".nav",
                    clickable: true,
                },
            });
        }

        $('.deepSlider3:not(.enabled)').each(function () {

            var $s = $(this);
            var leftButton = $s.find('> .buttons').length ? '> .buttons > .prev-slide' : '> .prev-slide';
            var rightButton = $s.find('> .buttons').length ? '> .buttons > .next-slide' : '> .next-slide';

            var args = $.extend({
                leftButton: leftButton,
                rightButton: rightButton,
                elToMove: '> .move',
                items: '> .slide',
                createNav: true,
                numbersNav: false,
                nav: '.nav',
                time: 700,
                continuousRewind: false,
                moveByElements: 1,
                jumpToElementCallback: function (i, cont, config) {
                    $s.find('.nav2 > *').eq(i).addClass('current').siblings().removeClass('current');
                }
            }, $s.data('slider'));

            $s.addClass('init');

            $s.deepSlider3(args);

            if (!isTouchDevice()) {
                $s.find('[data-zoom-src]').each(function () {
                    $(this).wrap('<span class="zoom-container"></span>').css('display', 'block').parent().zoom({
                        url: $(this).data('zoom-src'),
                        touch: false,
                        magnify: 1
                    });
                });
            }

            $s.find('.nav2 > *').on('click', function() {
                $(this).addClass('current').siblings().removeClass('current');
                $s.deepSlider3({jumpToElement: $(this).index()});
            });

            if (isTouchDevice()) {
                $s.find('ul.move > .slide').swipe(function (direction) {
                    if ($.inArray(direction, ['right']) !== -1) {
                        $s.deepSlider3('clickLeft');
                    } else if ($.inArray(direction, ['left']) !== -1) {
                        $s.deepSlider3('clickRight');
                    }
                });
            }
        });
    }

    function slider_swiper_loop() {
        $('.swiper.loop').each(function() {
            var w = $(this).outerWidth();
            var $s1 = $(this).find('.swiper-slide').eq(0);
            if (typeof $s1.attr('style') !== 'undefined') {
                return;
            }
            var iw = $s1.outerWidth();
            var slidesPerView = w && iw ? Math.round(w / iw) : 'auto';
            new Swiper(this, {
                slidesPerView: slidesPerView,
                loop: true,
                navigation: {
                    prevEl: '.prev-slide',
                    nextEl: '.next-slide',
                },
            });
        });
    }

    slider_init();

    $('.layout-collections_slider .tabs > *').on('click', function () {

        var $s = $(this);
        if ($s.hasClass('current')) {
            return;
        }

        $s.addClass('current').siblings().removeClass('current');
        var id = $s.data('id');
        $s.closest('.tabs').siblings('.sliders').find('> [data-slider="' + id + '"]').slideDown(500, function () {
            slider_swiper_loop();
        }).siblings().slideUp();
    });

    $b.on('click', '.lazyframe +.play-icon, iframe + .play-icon', function() {

        var $i = $(this).siblings('iframe');
        if (!$i.length) {
            $i = $(this).siblings('.lazyframe').find('> iframe')
        }
        var player = new Vimeo.Player($i);
        if ($(this).hasClass('played')) {
            $(this).removeClass('played');
            player.pause();
        } else {
            $(this).addClass('played');
            player.play();
        }
    });

    $('.search_container_icon').on('click', function () {

        $('html').toggleClass('openedSearch')

    });

    $('.slidescroll').each(function () {

        var $s = $(this), clicked = false, scrollLeft, clickX;

        if (($s.hasClass('length-1') || $s.hasClass('length-2')) && $(window).width() > 767) {
            return true;
        }

        $s.on({
            'mousemove': function(e) {
                clicked && updateScrollPos(e);
            },
            'mousedown': function(e) {
                clicked = true;
                clickX = e.pageX;
                scrollLeft = $s.scrollLeft();
            },
            'mouseup': function() {
                clicked = false;
            }
        });

        var updateScrollPos = function(e) {
            $s.scrollLeft(scrollLeft + (clickX - e.pageX));
        };

        /*$s.click(function () {
            $s.animate({'scrollLeft': scrollLeft + 200});
        })*/
    });

    function quickshop() {
        $('.quickshop').each(function () {

            var $s = $(this);
            var variants = $s.data('variants');
            var buttons1 = '';
            if (!variants) {
                if ($(this).hasClass('custom_variations')) {
                    buttons1 = $(this).siblings('.swatch_options2').outerHtml();
                    $(this).siblings('.swatch_options2').remove();
                    $(this).append(buttons1)
                }
                return true;
            }
            var prefix = '<span class="">Quick Shop</span>';
            var buttons = '';
            var hasColour = false;
            $.each(variants, function(variantID, options) {

                buttons += '<a href="/cart/add?id=' + variantID + '&quantity=1"';

                $.each(options, function(option_name, option_value) {

                    buttons += 'data-'+ option_name + '="' + option_value.replace(' ', '_').toLowerCase() + '" ';
                    if (option_name.indexOf('colour') >= 0 || option_name.indexOf('color') >= 0) {
                        hasColour = option_name;
                    }
                });

                var label = '';
                if (typeof options['size'] !== 'undefined') {
                    label = options['size'];
                } else if (Object.keys(options).length === 1) {
                    label = Object.values(options)[0];
                }

                buttons += ' rel="nofollow" >' +  label + '</a>';
            });

            if (hasColour) {
                var usedColours = [];
                $.each(variants, function (variantID, options) {
                    if ($.inArray(options[hasColour], usedColours) === -1) {
                        usedColours.push(options[hasColour]);
                        buttons1 += "<span data-colour='" + options[hasColour].replace(' ', '_').toLowerCase() + "' style='--image: url(" + options['image'] + ")'></span>";
                    }
                });
                if (usedColours.length > 1) {
                    buttons1 = '<span class="changeColour">' + buttons1 + '</span>';
                } else {
                    buttons1 = '';
                }
            } else if ($(this).hasClass('custom_variations')) {
                buttons1 = $(this).siblings('.swatch_options2').outerHtml();
                $(this).siblings('.swatch_options2').remove();
            }

            $s.html(prefix + buttons1 + buttons);

            if ($s.find('.changeColour').length) {
                var currentColour = $s.find('.changeColour').find('> span').eq(0).addClass('current').data('colour');
                $s.find('> [data-colour]').filter('[data-colour!="' + currentColour + '"]').hide();
                $s.find('.changeColour > span').on('click', function() {
                    $(this).addClass('current').siblings().removeClass('current')
                    $s.find('> [data-colour]').show().filter('[data-colour!="' + $(this).data('colour') + '"]').hide();
                });
            }
        });
    }

    quickshop();

    $(document).ajaxSuccess(function () {
        setTimeout(quickshop, 500);
        setTimeout(slider_init, 500);
        setTimeout(scroll_load, 500, $(document).scrollTop());
    });

    $('body').on('click', '.content-product .collection_swatches > span', function () {

        var $swatch = $(this);
        var $c = $swatch.closest('.content-product');
        $swatch.addClass('current').siblings().removeClass('current');

        $c.find('.image > .image-element__wrap > img').removeAttr('srcset data-src data-srcset').attr('src', $swatch.find('span').data('image'))

        var $q = $c.find('.quickshop');

        $q.find('a[data-' + $swatch.data('name') + '="' + $swatch.data('value') + '"]').show();
        $q.find('a[data-' + $swatch.data('name') + '!="' + $swatch.data('value') + '"]').hide();
    });


    $('form.shopify-product-form .mobile-title').on('click', function() {

        var $s = $(this);

        if ($s.hasClass('opened')) {
            $s.removeClass('opened').siblings('.content2').slideUp();
            return
        }

        $s.addClass('opened').siblings('.content2').slideDown();
    });

    $('.layout-team_members .right .item').on('mouseenter', function () {

        if ($(window).width() < 1024 || $h.hasClass('touch')) {
            return false;
        }

        var $s = $(this);
        if ($s.hasClass('current')) {
            return;
        }

        $s.addClass('current').siblings().removeClass('current');

        var $c = $s.closest('.inner').find('.left');

        $c.find('.image img').attr('src', $s.data('image')).removeAttr('srcset sizes');
        $c.find('.title2').html($s.data('title'));
        $c.find('.text').html($s.find('.text').html());
    });

    $('.easytabs-text, .read-more-js').each(function () {

        $(this).find('p:empty').remove();

        if ($(this).find('> p').length < 2) {
            return true;
        }
        $(this).find('> p').eq(0).append('<span class="read-more"><span class="dots">... </span> Read more</span>');

        $(this).find('> p').eq(-1).append('<span class="read-less"><span class="dots">... </span> Read less</span>');

        $(this).find('> p:not(:eq(0))').hide();

        $(this).find('.read-more').click(function () {
            $(this).closest('p').siblings('p').show();
            $(this).hide();
        });
    });

    $b.on('click', '.read-less', function() {

        $(this).closest('p').parent().find('p:not(:eq(0))').hide();
        $(this).closest('p').parent().find('.read-more').show()
    });


    function scrollSection(st) {

        $('.scroll-section-cont').each(function () {

            var $c = $(this);

            if(!$c.length) {
                return;
            }

            var $r = $c.find('> .scroll-section-reference');
            var $m = $c.find('> .scroll-section-move');

            if ($c.hasClass('ssc-mobile')) {
            } else if ($c.hasClass('ssc-portrait')) {
                if ($(window).width() < 768) {
                    $m.removeAttr('style').removeClass('fixed').removeClass('bottom');
                    return;
                }
            } else {
                if ($(window).width() < 1023) {
                    $m.removeAttr('style').removeClass('fixed').removeClass('bottom');
                    return;
                }
            }

            if ($m.outerHeight() * 1.5 > $r.outerHeight()) {
                $m.removeClass('fixed bottom').removeAttr('style');
                return;
            }

            var $header = $('#site-header');

            var top = $header.length ? $header.outerHeight() : 0;

            if (st > $c.offset().top - top) {

                $m.css({
                    'top' : top,
                    'width' : $m.width(),
                }).addClass('fixed');

                if (st > $r.offset().top + $r.outerHeight() - $m.outerHeight() - top) {
                    $m.addClass('bottom');
                } else {
                    $m.removeClass('bottom');
                }
            } else {
                $m.removeClass('fixed').css({
                    'top': '',
                    'width': '',
                });
            }
        });
    }

    function stickyAddToCart(st) {

        if (!$b.hasClass('product')) {
            return;
        }

        var $c = $('.product_form');
        if (!$c.length) {
            return;
        }

        var $f = $('.product_form > form');

        if (st > $c.offset().top + $c.outerHeight()) {
            if (!$h.hasClass('stickyAddToCart')) {
                $c.css({'min-height': $f.outerHeight()});
            }
            $h.addClass('stickyAddToCart');
        } else {
            $c.css({'min-height': ''});
            $h.removeClass('stickyAddToCart');
        }
    }

    function scroll_load(st) {
        $('.scroll_load').each(function () {
            var wh = $(window).height();
            var ot = $(this).offset().top;
            var pt = parseInt($(this).css('padding-top'));
            if (!$(this).hasClass('loaded') && ot + pt < st + wh) {
                $(this).addClass('loaded');
            }
        });
    }

    var parallax_boxes = function (st) {
        var i = 0;
        $('.parallax-box, .imageParallax > div.image-element__wrap > img').each(function () {

            if ($(this).hasClass('mob-no-parallax') && $(window).width() < 768) {
                $(this).removeAttr('style');
                return;
            }

            var ot = $(this).offset().top;
            var h = $(this).outerHeight();
            var wh = $(window).height();
            var speed = $(this).data('speed') ? $(this).data('speed') : 0.1;

            var imgParallax = $(this).parent().hasClass('image-element__wrap');
            if (imgParallax) {
                speed = 0.08
            }

            if (st < ot - wh || st > ot + wh) return;

            var p = ot + (h / 2);
            var c = st + (wh / 2);
            var t = Math.round((p - c) * speed);

            if ($(this).hasClass('pb-no-negative')) {
                t = t < 0 ? 0 : t;
            }

            var scale = imgParallax ? ' scale(1.2)' : '';
            $(this).css({
                '-webkit-transform': 'translate(0, ' + t + 'px)' + scale
            });
        });
    };

    var st = $(document).scrollTop();
    scroll_load(st);
    stickyAddToCart(st);
    scrollSection(st);
    parallax_boxes(st);

    $(window).on('scroll', function () {

        st = $(document).scrollTop();

        scroll_load(st);
        stickyAddToCart(st);
        scrollSection(st);
        parallax_boxes(st);

        st > 1000 ? $('#back-to-top').show() : $('#back-to-top').hide();

        $('.layout-scroll_gallery').each(function () {

            var $sg = $(this);
            var $sgp = $sg.find('.gap');

            var ww = $(window).width();
            var ot = $sg.offset().top;

            var t_w = $sg.find('.inner > *').totalOuterWidth();
            var inner_wider_by = t_w - ww;

            var sgp_h = inner_wider_by + $sg.find('.move').outerHeight();
            $sgp.css({'height': sgp_h});

            if (st > ot + inner_wider_by) {
                $sg.addClass('bottom');
            } else {
                $sg.removeClass('bottom');
            }

            if (st < ot || st > ot + inner_wider_by) {
                $h.removeClass('scrolledGallery');
            } else {
                $h.addClass('scrolledGallery');
            }

            st > ot ? $sg.addClass('fixed') : $sg.removeClass('fixed');

            if ($sg.hasClass('fixed')) {
                var x = st - ot;
                x = x > inner_wider_by ? inner_wider_by : x;

                $sg.find('.inner').css({'-webkit-transform': 'translate(-' + x + 'px, 0px)'});
            }

        });
    });


    $b.on('click', '#back-to-top', function () {

        $('html').animate({'scrollTop': 0});
    });


    $b.on('click', '.blog-header2 .blog-filter a ,.pagination-cont span.next a', function (e) {

        e.preventDefault();
        var $s = $(this);
        if ($s.hasClass('current')) {
            return false;
        }

        var $c = $('#blog-articles');
        var $p = $c.closest('.blog-articles-cont');
        var full = false;

        $p.addClass('loading');

        if ($s.parent('.blog-filter').length) {
            full = true;
            $c.slideUp();
            window.history.pushState({}, '', $s.attr('href'));
            $s.addClass('current').siblings().removeClass('current');
        } else {
            $s.closest('.paginate').hide();
            $p.addClass('more');
        }

        $.ajax({
            url: $s.attr('href'),
            dataType: 'html',
            type: 'GET',
            success: function (r) {

                $p.removeClass('loading more');
                if (full) {
                    $c.html($(r).find('#blog-articles').html());
                    $c.slideDown();
                } else {
                    $c.append($(r).find('#blog-articles').html());
                }

                $('#pagination-cont').html($(r).find('#pagination-cont').html());
            }
        });

        return false;
    });

    $b.on('click', '.jump-to-section', function() {

        var s = $(this).data('section');
        var $c = $('#' + s);

        if (!$c.length) return;

        var ot = $c.offset().top;

        $('html, body').animate({
            scrollTop: ot - 100
        }, 1000, 'swing');

    });

    $b.on('click', '.accordion-item > .title2', function () {

        var $s = $(this);

        if ($s.data('mobile') && $(window).width() > 1023) {
            return;
        }

        if ($s.parent().hasClass('opened')) {
            $s.parent().removeClass('opened').find('> .content2').slideUp();
            return;
        }

        $s.siblings('.content2').slideDown().closest('.accordion-item').addClass('opened').siblings('.accordion-item').removeClass('opened').find('> .content2').slideUp();
    });

    $b.on('click', '.accordion2 .nav-cont > *', function() {

        var $s = $(this);

        $s.addClass('current').siblings().removeClass('current');

        $s.closest('.accordion2').find('.blocks-cont > .block').eq($s.index()).slideDown().siblings().slideUp();
    });

    var $ProductGridContainer = $('#ProductGridContainer');
    var $deepFilter = $('#deep-filter');
    var $deepFilterComplete = $('#deep-filter-complete');
    var $min = $deepFilterComplete.find('.range-input input.min');
    var $max = $deepFilterComplete.find('.range-input input.max');
    var $min2 = $deepFilterComplete.find('.range-price input[name="min"]');
    var $max2 = $deepFilterComplete.find('.range-price input[name="max"]');

    load_products = function(suffix) {

        if (!$ProductGridContainer.length) {
            return;
        }

        var $a = $ProductGridContainer.closest('.ajax-loading-cont');

        //var href = 'https://www.lockhatters.co.uk/api/collection.php?customer_id=' + $ProductGridContainer.data('customer');

        var href = "https://www.lockhatters.com/collections/"
        if ($ProductGridContainer.data('collection')) {
            href += $ProductGridContainer.data('collection')+"?";
        }

        if ($deepFilterComplete.find('input[type=checkbox][name=selection]:checked').length) {

            var filter = [];
            var colours = [];
            var sizes = []
            var style = [];
            var product_type = [];
            $deepFilterComplete.find('input[type=checkbox][name=selection]:checked').each(function () {
                if ($(this).parent().prev().text()==="Colour") {
                    colours.push($(this).val().replace(/^\s+/g, '').replace(/ /,'+'))
                } else if ($(this).parent().prev().text()==="Size") {
                    sizes.push($(this).val().replace(/^\s+/g, '').replace(/ /,'+'))
                } else if ($(this).parent().prev().text()==="Style") {
                    style.push($(this).val().replace(/^\s+/g, '').replace(/ /,'+'))
                } else if ($(this).parent().prev().text()==="Gender") {
                    product_type.push($(this).val().replace(/^\s+/g, '').replace(/ /,'+'))
                }else {
                    filter.push($(this).val().replace(/^\s+/g, '').replace(/ /,'+'))
                }


            });

            href += '&filter.p.tag=' + filter.join(',');
            href += '&filter.p.product_type=' + product_type.join(',').toLowerCase();
            href += '&filter.v.option.colour=' + colours.join(',');
            href += '&filter.v.option.size=' + sizes.join(',');
            href += '&filter.p.m.custom.style_title=' + style.join(',');
        }

        if (parseInt($min.val()) > parseInt($min.attr('min')) || parseInt($max.val()) < parseInt($max.attr('max'))) {
            href += '&filter.v.price.gte=' + $min.val();
            href += '&filter.v.price.lte=' + $max.val();
        }

        if ($deepFilter.find('.sortby > select').val()) {
            href += '&sort_by=' + $deepFilter.find('.sortby > select').val();
        }

        if (suffix) {
            href += suffix;
        }

        $a.addClass('loading');
        if (href.includes('cursor')) {
            $a.addClass('more');
        } else {
            $ProductGridContainer.slideUp();

            if ($('#guide-part .content-product').length) {
                href += '&guide=1';
            }
            if ($('#collection-faqs-part .content-product').length) {
                href += '&accordion=1';
            }
        }

        $.ajax({
            url: href,
            dataType: 'html',
            type: 'GET',
            success: function (html) {

                $a.removeClass('loading');

                if (href.includes('cursor')) {
                    $ProductGridContainer.append(html);
                    $a.removeClass('more');
                } else {
                    var guide = '', accordion = '';
                    if ($('#guide-part .content-product').length) {
                        guide = $('#guide-part').html();
                    }
                    if ($('#collection-faqs-part .content-product').length) {
                        accordion = $('#collection-faqs-part').html();
                    }
                    html = html.replace(/#guide_placeholder#/, guide);
                    html = html.replace(/#accordion_placeholder#/, accordion);
                    if ($('#ProductGridContainer',html).length) {
                        $ProductGridContainer.html($('#ProductGridContainer',html).html());
                    } else {
                        $ProductGridContainer.html("<p class=\"quote\">No products found in this collection</p>");
                    }
                    $ProductGridContainer.slideDown()
                }
            }
        });
    };

    $b.on('click', '.load-more-products', function () {

        var $s = $(this);

        var suffix = '&cursor=' + $s.data('cursor') + '&items_count=' + $ProductGridContainer.find('> .content-product').length;

        if ($s.closest('.layout-questionnaire').length) {
            $s.parent().remove();
            load_questionnaire_results(suffix);
        } else {
            $s.parent().remove();
            load_products(suffix);
        }
    });

    var load_products2 = true;

    $('#deep-filter input[type=checkbox][name=selection]').change(function() {
        $deepFilterComplete.find('input[value="' + $(this).val() + '"]').prop('checked', $(this).is(':checked')).change();

        if (load_products2) {
            load_products();
        }
    });

    $('#deep-filter .sortby > select').change(function () {
        load_products();
    });

    $('#deep-filter-complete input[type=checkbox][name=selection]').change(function() {

        load_products2 = false;
        $deepFilter.find('input[value="' + $(this).val() + '"]').prop('checked', $(this).is(':checked'));
        load_products2 = true;
    });

    $('#deep-filter-complete .apply').click(function () {
        $('#deep-filter-complete').removeClass('opened');
        load_products();
    });

    $('#deep-filter .clearall, #deep-filter-complete .clearall').click(function () {
        $deepFilter.find('input[type=checkbox]').prop('checked', false);
        $deepFilterComplete.find('input[type=checkbox]').prop('checked', false);
        $min.val($min.attr('min')).change();
        $max.val($max.attr('max')).change();
        $min2.val($min2.attr('min')).change();
        $max2.val($max2.attr('max')).change();
        $deepFilter.find('.sortby > select').val('').change();
    });

    $('#deep-filter .more').click(function () {
        $('#deep-filter-complete').addClass('opened')
    });

    $('#deep-filter-complete .close').click(function () {
        $('#deep-filter-complete').removeClass('opened')
    });

    const range = document.querySelector(".range-selected");
    const rangeInput = document.querySelectorAll(".range-input input");
    const rangePrice = document.querySelectorAll(".range-price input");

    rangeInput.forEach((input) => {
        input.addEventListener("input", (e) => {
            let minRange = parseInt(rangeInput[0].value);
            let maxRange = parseInt(rangeInput[1].value);
            if (maxRange - minRange < rangeInput[0].min) {
                if (e.target.className === "min") {
                    rangeInput[0].value = maxRange - rangeMin;
                } else {
                    rangeInput[1].value = minRange + rangeMin;
                }
            } else {
                rangePrice[0].value = minRange;
                rangePrice[1].value = maxRange;
                range.style.left = (minRange / rangeInput[0].max) * 100 + "%";
                range.style.right = 100 - (maxRange / rangeInput[1].max) * 100 + "%";
            }
        });
    });

    $b.on('click', '.toggle-slide', function () {
        $(this).closest('.item').find('.toggle').slideToggle();
    });

    $b.on('focus', '.focus-effect input, .focus-effect textarea', function () {

        $(this).closest('.focus-effect').addClass('filled');
    }).on('focusout', '.focus-effect input, .focus-effect textarea', function () {

        if (!$(this).val()) {
            $(this).closest('.focus-effect').removeClass('filled');
        }
    });

    function init_focus_effect() {
        $('.focus-effect input, .focus-effect textarea').each(function () {
            if ($(this).val() || $(this).is(':-webkit-autofill')) {
                $(this).closest('.focus-effect').addClass('filled');
            }
        });
    }

    setTimeout(init_focus_effect, 1000);

    $b.on('click', '.a-jump-to a[href^="#"]', function () {

        var id = $(this).attr('href');
        var ot;

        if (id === '#') {
            ot = 0;
        } else {
            if (!$(id).length) return;
            ot = $(id).offset().top;
        }

        $('html, body').animate({
            scrollTop: ot
        }, 1000, 'swing');

        return false;
    });

    $('.toggle').click(function(){

        $(this).closest('.toggle-cont').toggleClass('active')
    });

    $b.on('click', '.open-lightbox2', function () {

        var content = $(this).siblings('.lightbox2-content').html();

        $('#lightbox2').removeClass().addClass($(this).data('class')).html('<div class="inner">'+content+'<div class="close-lightbox2 exit"></div></div>').addClass('show2');
    });

    $b.on('click', '.close-lightbox2', function () {

        $('#lightbox2').removeClass().html('');
    });

    $b.on('click', '.open-lightbox2-h > *', function () {

        var content = $('#heritage-item-' + $(this).data('open')).find('.lightbox2-content').html();
        $('#lightbox2').html('<div class="inner">'+content+'<div class="close-lightbox2 exit"></div></div>');
    });

    var $heritage = $('.layout-heritage');

    if ($heritage.length) {

        var $o = $heritage.find('.outer'),
            $i = $o.find('> .inner');

        $('header > .header').addClass('hide2').on('mouseleave', function () {
            $(this).addClass('hide2');
        });

        $('#header').addClass('hide2');
        $(document).on('touchstart', function (e) {
            var $h = $('#header');
            if (!$h.hasClass('hide2') && !$h.is(e.target) && $h.has(e.target).length === 0) {
                $h.addClass('hide2');
            }
        });

        $heritage.find('.nav .menu').on('click', function() {

            $('header > .header').removeClass('hide2');
            $('#header').removeClass('hide2');
        });

        $heritage.find('.nav .view > span').on('click', function() {

            $heritage.find('.outer').removeClass('gallery list').addClass($(this).data('view'));
            $(this).addClass('current').siblings().removeClass('current');
            $i.removeAttr('style');
        });

        if (isTouchDevice()) {
            $o.animate({
                'scrollTop' : ($i.outerHeight() / 2) - ($o.outerHeight() / 2),
                'scrollLeft' : ($i.outerWidth() / 2) - ($o.outerWidth() / 2)
            })
        }

        $o.on('mousemove', function (e) {

            if (!$(this).hasClass('gallery') || isTouchDevice()) {
                $i.removeAttr('style');
                return;
            }

            var pos, x, y;

            e.preventDefault();

            pos = getCursorPos(e, $o[0]);

            var o_w = $o.outerWidth();
            var i_w = $i.outerWidth();
            var o_h = $o.outerHeight();
            var i_h = $i.outerHeight();

            x = (pos.x / (o_w / 2) - 1) * ((i_w - o_w) / 2);
            y = (pos.y / (o_h / 2) - 1) * ((i_h - o_h) / 2);

            $i.css({
                '-webkit-transform': 'translate(' + (-x) + 'px, ' + (-y) + 'px)'
            });
        });
    }

    function getCursorPos(e, s) {
        var a, x, y;
        e = e || window.event;
        a = s.getBoundingClientRect();
        x = e.pageX - a.left;
        y = e.pageY - a.top;
        x = x - window.pageXOffset;
        y = y - window.pageYOffset;
        return {x: x, y: y};
    }

    $b.on('click', '.questionnaire-form .question .next:not(:disabled)', function () {

        if (!$('.questionnaire-form .question_' + $(this).data('current')).find('input[type="radio"]:checked').length) {
            return;
        }

        $('.questionnaire-form .question_' + $(this).data('question')).slideDown().siblings().slideUp();

        if ($(this).hasClass('view-results')) {
            var $f = $(this).closest('.questionnaire-form');
            $f.slideUp().siblings('.results').slideDown();
            load_questionnaire_results();
        }
    });

    function load_questionnaire_results(suffix) {
        var $f = $('.questionnaire-form');
        var $c = $f.siblings('.results').find('.items > .inner');
        var $a = $c.closest('.ajax-loading-cont');
        var $t = $a.siblings('.title2');
        var e = $t.data('example');

        var href = 'https://www.lockhatters.co.uk/api/collection.php?questionnaire=1&tag-and=1&customer_id=' + $ProductGridContainer.data('customer');

        if ($f.find('input[type=radio]:checked').length) {

            var filter = [];
            var i = 0;
            $f.find('input[type=radio]:checked').each(function () {
                i++;
                filter.push($(this).val().replace(/ /,'%20'));
                var $t = $(this).siblings('label[for="' + $(this).attr('id') + '"]').find('span');
                var replace = $t.data('result_text') ? $t.data('result_text') : $t.text().toLowerCase();
                e = e.replace('*answer_' + i + '*', replace);
            });
            href += '&filter=' + filter.join(',')
        }

        $a.addClass('loading');
        $t.html(e);

        if (suffix) {
            href += suffix;
            $a.addClass('more');
        } else {
            $c.slideUp();
        }

        $.ajax({
            url: href,
            dataType: 'html',
            type: 'GET',
            success: function (html) {

                $a.removeClass('loading more');
                if (suffix) {
                    $c.append(html);
                } else {
                    $c.html(html).slideDown();
                }
            }
        });
    }

    $b.on('change', '.questionnaire-form .question input[type="radio"]', function() {
        $(this).closest('.question').find('.next').removeAttr('disabled');

        var val = $(this).val();
        if ($.inArray(val, ['female', 'male']) !== -1) {
            $('.questionnaire-form .question label').each(function () {
                if ($(this).closest('.question').hasClass('question_1')) {
                    return true;
                }
                if (val === 'female') {
                    $(this).find('img').removeAttr('srcset data-src data-sizes data-srcset').removeClass('lazyLoad').attr('src', $(this).data('female'))
                } else if (val === 'male') {
                    $(this).find('img').removeAttr('srcset data-src data-sizes data-srcset').removeClass('lazyLoad').attr('src', $(this).data('male'))
                }
            });
        }
    });

    $b.on('click', '.layout-questionnaire .results .back', function() {

        var $r = $(this).closest('.results');
        var $f = $r.siblings('.questionnaire-form');

        $f.find('.next').attr('disabled', true);
        $f.find('input[type="radio"]').prop('checked', false);
        $r.slideUp();
        $f.slideDown().find('.question_1').slideDown().siblings().slideUp();
        $('html, body').animate({
            scrollTop: 0
        });
    });

    $('header#header ul#mobile_menu a.open-submenu').on('click', function() {

        $(this).siblings('ul.sub-menu').show();
        return false;
    });

    $('header#header ul#mobile_menu .back').on('click', function() {

        $(this).closest('ul.sub-menu').hide();
        return false;
    });

    $b.on('click', '.find-your-size', function() {
        var $c = $('#hat_sizing_calculator');
        if ($c.length) {
            $c.show();
            return false;
        }
    });
    $b.on('click', '.how-to-measure', function() {
        var $c = $('#hat_sizing_calculator2');
        if ($c.length) {
            $c.show();
            return false;
        }
    });
    $b.on('click', '.hat_sizing_calculator .close', function() {
        $(this).closest('.hat_sizing_calculator').hide();
    });

});
